import moment from "moment";

const dateConversion = (date: string, format: string) => {
    return moment(date).format(format);
}

const validateDateIsBeetween = (startDate: Date, endDate: Date, date: string) => {
    return moment(date).isBetween(startDate, endDate);
}

export {
    dateConversion,
    validateDateIsBeetween,
}